import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPriority(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="M8.45 2.45a.45.45 0 1 0-.9 0c0 1.872-.413 3.117-1.198 3.902S4.322 7.55 2.45 7.55a.45.45 0 1 0 0 .9c1.872 0 3.117.413 3.902 1.198s1.198 2.03 1.198 3.902a.45.45 0 0 0 .9 0c0-1.872.413-3.117 1.198-3.902s2.03-1.198 3.902-1.198a.45.45 0 0 0 0-.9c-1.872 0-3.117-.413-3.902-1.198S8.45 4.322 8.45 2.45"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPriority);
export default ForwardRef;
